import React from 'react';
import { Flex } from '@applyboard/crystal-ui';
import { ScholarshipTitleHeader } from "../ScholarshipTitleHeader";
import { ScholarshipInfoBox } from "../ScholarshipInfoBox";
import { ScholarshipOverview } from "../ScholarshipOverview";
import { ScholarshipAdminNote } from "../ScholarshipAdminNote";
import { OtherScholarships } from "../OtherScholarships";
import { useScholarshipPageContext } from "../../contexts";
import { ScholarshipEligibleNationalities } from "../ScholarshipEligibleNationalities";
import { ScholarshipEligibleLevels } from "../ScholarshipEligibleLevels";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var ScholarshipPageLayout = function ScholarshipPageLayout() {
  var _useScholarshipPageCo = useScholarshipPageContext(),
    scholarship = _useScholarshipPageCo.scholarship;
  return _jsxs(Flex, {
    direction: "column",
    px: {
      xs: 8,
      lg: 32
    },
    gap: 8,
    pb: 20,
    children: [_jsx(ScholarshipTitleHeader, {}), _jsx(ScholarshipInfoBox, {}), _jsx(ScholarshipOverview, {}), _jsx(ScholarshipEligibleNationalities, {
      eligibleNationalities: scholarship.eligibleNationalities
    }), _jsx(ScholarshipEligibleLevels, {
      eligibleLevels: scholarship.eligibleLevels
    }), _jsx(ScholarshipAdminNote, {}), _jsx(OtherScholarships, {
      schoolGroupId: scholarship.schoolGroupId
    })]
  });
};